export default "__VITE_ASSET__B_EJKXQ9__"